import React from 'react'

import { Player } from 'video-react'

import {
    EuiText,
    EuiIcon,
    EuiPanel
  } from '@elastic/eui'

import { OutboundLink } from 'gatsby-plugin-gtag'

require('../../../Layout/chrome/assets/video.css')

function VideoCard() {
  return (
    <EuiPanel paddingSize="m">
        <Player>
            <source src="https://wiki.instar.com/videos/Unboxing_der_neuen_IN8015_Full_HD_IP_Kamera.mp4" />
        </Player>
        <EuiText>
            <p>Die ganz neue INSTAR IN-8015 Full HD. Das Flagschiff unter den IP Innenkameras. Dank eines Panasonic WDR Bildsensors erzeugt die IN-8015 sagenhafte Aufnahmen bei Tag als auch bei Nacht. </p>
            <p>Der eingebaute PIR Wärmesensor verhindert zudem das die Kamera Fehlalarme erzeugt und eine mitgelieferte 16GB MicroSD Speicherkarte ermöglicht das Aufnahmen der Alarm Videos von bis zu mehr als einem Monat. Wem das nicht reicht, der kann bis zu 128GB MicroSD Speicherkarten in die Kamera einsetzen. Auf <OutboundLink href="https://www.youtube.com/watch?v=gwjk_epTyaY" target="_blank" rel="noopener noreferrer">Youtube ansehen <EuiIcon type="popout" /></OutboundLink></p>
        </EuiText>
    </EuiPanel>
  );
}

export default VideoCard